/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Targetorchestratorv2Dependency } from '../models/Targetorchestratorv2Dependency';
import { Targetorchestratorv2Miscellanea } from '../models/Targetorchestratorv2Miscellanea';
import { Targetorchestratorv2SystemStat } from '../models/Targetorchestratorv2SystemStat';
import { HttpFile } from '../http/http';

export class Targetorchestratorv2Checks {
    'systemStat'?: Targetorchestratorv2SystemStat;
    'dependencies'?: Array<Targetorchestratorv2Dependency>;
    'miscellaneous'?: Array<Targetorchestratorv2Miscellanea>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "systemStat",
            "baseName": "systemStat",
            "type": "Targetorchestratorv2SystemStat",
            "format": ""
        },
        {
            "name": "dependencies",
            "baseName": "dependencies",
            "type": "Array<Targetorchestratorv2Dependency>",
            "format": ""
        },
        {
            "name": "miscellaneous",
            "baseName": "miscellaneous",
            "type": "Array<Targetorchestratorv2Miscellanea>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Targetorchestratorv2Checks.attributeTypeMap;
    }

    public constructor() {
    }
}

